import LandingPlane from "./images/icons/airplane-landing.svg";
import TakeOffPlane from "./images/icons/airplane-takeoff.svg";
import Calendar from "./images/icons/calendar.svg";
import Users from "./images/icons/users.svg";
import ExchangeArrow from "./images/icons/exchange-arrow.svg";
import Times from "./images/icons/times.svg";
import Check from "./images/icons/check.svg";
import Meal from "./images/icons/meal.svg";
import Baggage from "./images/icons/baggage.svg";



export const icons = {
  LandingPlane,
  TakeOffPlane,
  Calendar,
  Users,
  ExchangeArrow,
  Times,
  Check,
  Meal,
  Baggage,
}